import { useState } from "react";
import { Link } from "react-router-dom";
// import { signIn } from "next-auth/react";
import routes from "@/routers/routes";
import { Form } from "@/ui/form";
import { loginSchema, LoginSchema } from "@/validators/login.schema";
import { SubmitHandler } from "react-hook-form";
import { PiArrowRightBold } from "react-icons/pi";
import { Button, Checkbox, Input, Password, Text } from "rizzui";

const initialValues: LoginSchema = {
    email: "admin@admin.com",
    password: "admin",
    rememberMe: true,
};

export default function SignInForm() {
    //TODO: why we need to reset it here
    const [reset, _setReset] = useState({});

    const onSubmit: SubmitHandler<LoginSchema> = (data) => {
        console.log(data);
        // signIn("credentials", {
        //   ...data,
        // });
    };

    return (
        <>
            <Form<LoginSchema>
                validationSchema={loginSchema}
                resetValues={reset}
                onSubmit={onSubmit}
                useFormProps={{
                    defaultValues: initialValues,
                }}
            >
                {({ register, formState: { errors } }) => (
                    <div className="space-y-5">
                        <Input
                            type="email"
                            size="lg"
                            label="Email"
                            placeholder="Enter your email"
                            className="[&>label>span]:font-medium"
                            inputClassName="text-sm"
                            {...register("email")}
                            error={errors.email?.message}
                        />
                        <Password
                            label="Password"
                            placeholder="Enter your password"
                            size="lg"
                            className="[&>label>span]:font-medium"
                            inputClassName="text-sm"
                            {...register("password")}
                            error={errors.password?.message}
                        />
                        <div className="flex items-center justify-between pb-2">
                            <Checkbox
                                {...register("rememberMe")}
                                label="Remember Me"
                                className="[&>label>span]:font-medium"
                            />
                            <Link
                                to={routes.auth.forgotPassword1}
                                className="h-auto p-0 text-sm font-semibold text-blue underline transition-colors hover:text-gray-900 hover:no-underline"
                            >
                                Forget Password?
                            </Link>
                        </div>
                        <Button className="w-full" type="submit" size="lg">
                            <span>Sign in</span>{" "}
                            <PiArrowRightBold className="ms-2 mt-0.5 h-5 w-5" />
                        </Button>
                    </div>
                )}
            </Form>
            <Text className="mt-6 text-center leading-loose text-gray-500 lg:mt-8 lg:text-start">
                Don’t have an account?{" "}
                <Link
                    to={routes.auth.signUp1}
                    className="font-semibold text-gray-700 transition-colors hover:text-blue"
                >
                    Sign Up
                </Link>
            </Text>
        </>
    );
}
